import React, { useState } from 'react'
import DashboardKpiStatus from "components/DashboardKpiStatus";
import { overviewChartPalette } from "styles/theme";
import { Avatar, Box, Card, CardContent, Grid, Typography } from '@mui/material'
import { FaRupeeSign } from 'react-icons/fa'
import { CiCalendar } from 'react-icons/ci'
import { Error, Loader } from './common';
import { VscPercentage } from 'react-icons/vsc';
import { formatNumber } from 'utils/reusable';
import HseListPopUp from './hseListPopup';

const kpisArr = [
    {
        key: "totalSafeManHours",
        label: "Total Safe Man Hours",
        value: "3600",
        bg: "#FFF4DE",
        iconBg: "#FF947A",
        type: "progress",
        format: true
    },
    {
        key: "totalFatilityCase",
        label: "Total No. of fatality Case",
        value: 0,
        bg: "#FFF4DE",
        iconBg: "#FF947A",
        isLocal: false,
        status: "Fatal"
    },
    {
        key: "nearMissIncidents",
        label: "Total Near Miss",
        value: "2",
        bg: "#FFF4DE",
        iconBg: "#FF947A",
        isLocal: false,
        status: "Near Miss"
    },
    {
        key: "totalRecordedIncidents",
        label: "Total other Incidents Recorded",
        value: 0,
        bg: "#FFF4DE",
        iconBg: "#FF947A",
        isLocal: false,
        status: "Recorded"
    },

    // {
    //     key: "openNCRs",
    //     label: "Open NCR",
    //     value: "2",
    //     bg: "#FFF4DE",
    //     iconBg: "#FF947A",
    // },
    // {
    //     key: "closedNCRs",
    //     label: "Closed NCR",
    //     value: "4",
    //     bg: "#DCFCE7",
    //     iconBg: "#3CD856",
    // },
    // {
    //     key: "totalManHours",
    //     label: "Total Man Hours",
    //     value: "3600",
    //     bg: "#FFF4DE",
    //     iconBg: "#FF947A",
    //     type: "progress",
    // },

    {
        key: "ltifr",
        label: "LTIFR",
        value: 10,
        bg: "#F3E8FF",
        iconBg: "#BF83FF",
        subTexts: [
            { label: "Lost Time Injury Frequency Rate" }
        ],
        isLocal: false
    },
    {
        key: "trir",
        label: "TRIR",
        value: 0,
        bg: "#F3E8FF",
        iconBg: "#BF83FF",
        subTexts: [
            { label: "Total Recordable Incident Rate" }
        ],
        isLocal: false
    },
    // {
    //     key: "baheviorSafetyScore",
    //     label: "Behaviour Based Safety Score",
    //     value: 1,
    //     bg: "#F3E8FF",
    //     iconBg: "#BF83FF",
    // },
    {
        key: "legalCompliance",
        label: "Legal Compliance",
        value: "100%",
        bg: "#DCFCE7",
        iconBg: "#3CD856",
        isLocal: true

    }
];


const getKpiBg = (item) => {
    if (item.key === "ltifr") {
        return item.value > 10 ? "#FFE2E5" : "#DCFCE7"
    }
    if (item.key === "trir") {
        return item.value > 3 ? "#FFE2E5" : "#DCFCE7"
    }
    if (item.key === "totalFatilityCase") {
        return item.value == 0 ? "#DCFCE7" : "#FFF4DE"
    }
    return item.bg
}

const getIconBg = (item) => {
    if (item.key === "ltifr") {
        return item.value > 10 ? overviewChartPalette.coral : overviewChartPalette.teal
    }
    if (item.key === "trir") {
        return item.value > 3 ? overviewChartPalette.coral : overviewChartPalette.teal
    }
    if (item.key === "totalFatilityCase") {
        return item.value == 0 ? overviewChartPalette.teal : overviewChartPalette.amber
    }
    return item.iconBg
}
const IncidentKpis = ({ kpis, isLoading, isError }) => {

    const [status, setStatus] = useState("")
    const [isPopup, setIsPopup] = useState(false)
    const [header, setHeader] = useState("")

    // const updatedKpis = kpisArr.map(item => ({ ...item, value: kpis[item.key] }))


    const handleClick = (label, status) => {
        const filters = {
            TypeOfIncident: status === "Recorded" ? "" : status,
            IsNotNearMissNeeded: status === "Recorded"
        };

        setStatus(filters); 
        setHeader(label);
        setIsPopup(true);
    };



    const handleClose = () => {
        setIsPopup(false);
    };



    const updatedKpis = kpisArr.map(item => ({
        ...item,
        value: item.isLocal ? item.value : kpis[item.key],
        totalSafeManHours: kpis.totalSafeManHours || 0,
        totalManHours: kpis.totalManHours || 0
    }));

    const clickable = [
        "Total other Incidents Recorded",
        "Total Near Miss",
        "Total No. of fatality Case",
    ];

    return (
        <>
            <Box
                elevation={0}
                sx={{
                    borderRadius: "3px",
                    border: "1px solid #eef0f4",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    boxSizing: "border-box",
                    p: "20px 20px 20px 20px",
                    maxHeight: { xs: "auto", md: "316px" },
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 600,
                        fontSize: "15px",
                        lineHeight: "21px",
                        letterSpacing: "0px",
                        color: "#05004E",
                    }}
                >
                    HSE Intelligence
                </Typography>
                <Typography
                    sx={{
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 400,
                        fontSize: "12px",
                        lineHeight: "16px",
                        letterSpacing: "0px",
                        color: "#737791",
                        mb: 2,
                    }}
                >
                    Core Metrics Reflecting Site Safety & Compliance.
                </Typography>

                {isLoading && <Loader isLoading={isLoading} />}
                {isError && <Error isError={isError} />}

                {!isLoading && !isError && <Grid
                    container
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
                        gap: 1.25,
                        width: "100%",
                        "& > .MuiGrid-root": { minWidth: 0, width: "auto", maxWidth: "none" },
                        "& .MuiCard-root": { transition: "border-color 140ms ease, box-shadow 140ms ease, transform 140ms ease" },
                        "& .MuiCard-root:hover": { borderColor: "#CBD5E1", boxShadow: "0 4px 12px rgba(15, 23, 42, 0.08)", transform: "translateY(-1px)" },
                    }}
                >
                    {updatedKpis?.map((item) => (
                        <Grid
                            xs={12}
                            sm={6}
                            md={12 / 7}
                            key={item.label}
                            sx={{ minWidth: 0 }}
                        >
                            <Card
                                elevation={0}
                                onClick={() =>
                                    item.label === "Total other Incidents Recorded" ||
                                        item.label === "Total No. of fatality Case" ||
                                        item.label === "Total Near Miss"
                                        ? handleClick(item.label, item.status)
                                        : undefined
                                }
                                sx={{
                                    height: "128px",
                  position: "relative",
                                    // width: { minWidth: "200px", minWidth: "100%" },

                                    borderRadius: "3px",
                                    backgroundColor: "#FFFFFF",
                                        border: "1px solid #E2E8F0",
                                        borderBottom: `3px solid ${getIconBg(item)}`,
                                    cursor: clickable.includes(item.label)
                                        ? "pointer"
                                        : "default"
                                }}
                            >
                                <CardContent sx={{ gap: 1, p: 1.25, pt: 1.25 }}>
                                    <Avatar
                                        sx={{
                                            width: 30,
                                            height: 30,
                                            backgroundColor: getIconBg(item),
                                            fontSize: 18,
                                            fontWeight: 700,
                                        }}
                                    >
                                        {item.type === "progress" ? <CiCalendar /> : <CiCalendar />}
                                    </Avatar>
                                    <DashboardKpiStatus color={getIconBg(item)} />

                                    {item.type === "progress" ? <>
                                        {/* Actual vs Plan text */}
                                        <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mt: "4px" }}>
                                            <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#151D48" }}>
                                                {item.format ? formatNumber(item.totalSafeManHours) : item.totalSafeManHours}
                                            </Typography>
                                            <Typography sx={{ fontWeight: 500, fontSize: "12px", color: "#667085" }}>
                                                of {item.format ? formatNumber(item.totalManHours) : item.totalManHours}
                                            </Typography>
                                        </Box>
                                        <Typography sx={{ fontWeight: 500, fontSize: "12px", color: "#667085", textAlign: "right" }}>
                                            Total Man Hours
                                        </Typography>

                                        {/* Mini progress bar */}
                                        <Box sx={{ mt: 1.5 }}>
                                            <Box sx={{ height: 6, borderRadius: 999, backgroundColor: "#E4E7EC", overflow: "hidden" }}>
                                                <Box
                                                    sx={{
                                                        width: `${Math.min((item.totalSafeManHours / item.totalManHours) * 100, 100)}%`,
                                                        height: "100%",
                                                        borderRadius: 999,
                                                        background: item.totalSafeManHours >= item.totalManHours
                                                            ? "#12B76A" // Green if target met
                                                            : "#1073F6", // Blue if in progress
                                                        transition: "width 0.3s ease",
                                                    }}
                                                />
                                            </Box>
                                        </Box>

                                        {/* Label */}
                                        <Typography
                                            sx={{
                                                fontFamily: "Outfit, sans-serif",
                                                fontWeight: 500,
                                                lineHeight: "16px",
                                                fontSize: "12px",
                                                letterSpacing: "0px",
                                                color: "#425166",
                                                mt: "4px",
                                            }}
                                        >
                                            {item.label}
                                        </Typography>
                                    </> : <>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                gap: "13px",
                                                mt: "4px",
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontFamily: "Outfit, sans-serif",
                                                    fontWeight: 600,
                                                    fontSize: "16px",
                                                    lineHeight: "21px",
                                                    color:
                                                        item.type === "percentage" ? "#FF383C" : "#151D48",
                                                }}
                                            >
                                                {item.value}
                                            </Typography>
                                        </Box>
                                        <Typography
                                            sx={{
                                                fontFamily: "Outfit, sans-serif",
                                                fontWeight: 500,
                                                lineHeight: "16px",
                                                fontSize: "12px",
                                                letterSpacing: "0px",
                                                color: "#425166",
                                                mt: "4px",
                                            }}
                                        >
                                            {item.label}
                                        </Typography>
                                        {item?.subTexts?.length && (
                                            <>
                                                {item.subTexts.map((subItem) => (
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            fontFamily: "Outfit, sans-serif",
                                                            fontWeight: 400,
                                                            fontSize: "12px",
                                                            color: "#4B5563",
                                                        }}
                                                    >
                                                        {subItem.label}
                                                        {/* : <strong>₹ {subItem.value}</strong> */}
                                                    </Typography>
                                                ))}
                                            </>
                                        )}
                                    </>}
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>}


            </Box>
            {isPopup && (
                <HseListPopUp
                    header={header}
                    open={isPopup}
                    handleClose={handleClose}
                    filter={status}
                />
            )}

        </>
    )
}

export default IncidentKpis
